// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1zutY","btn":"styles_btn__2UCIV"};